import classNames from 'classnames';
import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import * as styles from './TeamIcon.module.scss';

interface TeamIconProps {
  size?: 'small' | 'regular' | 'medium' | 'large' | 'xlarge';
}

interface TeamIconInnerProps {
  logo?: string;
  name: string;
  size: TeamIconProps['size'];
}

export const TeamIconInner = ({ name, logo, size }: TeamIconInnerProps) => {
  const classes = classNames(styles.teamIconDefault, {
    [styles.small]: size === 'small',
    [styles.regular]: size === 'regular',
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.xlarge]: size === 'xlarge',
    [styles.withBackground]: logo == null,
  });

  return logo ? (
    <span className={classes} style={{ backgroundImage: `url(${logo})` }} />
  ) : (
    <span className={classes}>{name[0]?.toUpperCase()}</span>
  );
};

const TeamIcon = ({ size = 'regular' }: TeamIconProps) => {
  const sessionOrg = useAppSelector((state) => state.session.organization);
  const publicOrg = window.__slab.PUBLIC_ORG;

  const organization = sessionOrg.id ? sessionOrg : publicOrg;
  const { name } = organization;

  return (
    <TeamIconInner
      name={name}
      logo={organization?.logo?.thumb || undefined}
      size={size}
    />
  );
};

export default TeamIcon;
